import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/app/actions.js'), 'app/actions.js')
  resolveStoreModules(require('../store/app/getters.js'), 'app/getters.js')
  resolveStoreModules(require('../store/app/mutations.js'), 'app/mutations.js')
  resolveStoreModules(require('../store/app/state.js'), 'app/state.js')
  resolveStoreModules(require('../store/auth/actions.js'), 'auth/actions.js')
  resolveStoreModules(require('../store/auth/getters.js'), 'auth/getters.js')
  resolveStoreModules(require('../store/auth/mutations.js'), 'auth/mutations.js')
  resolveStoreModules(require('../store/auth/state.js'), 'auth/state.js')
  resolveStoreModules(require('../store/featureFlags/actions.js'), 'featureFlags/actions.js')
  resolveStoreModules(require('../store/featureFlags/mutations.js'), 'featureFlags/mutations.js')
  resolveStoreModules(require('../store/featureFlags/state.js'), 'featureFlags/state.js')
  resolveStoreModules(require('../store/flags/actions.js'), 'flags/actions.js')
  resolveStoreModules(require('../store/flags/getters.js'), 'flags/getters.js')
  resolveStoreModules(require('../store/flags/mutations.js'), 'flags/mutations.js')
  resolveStoreModules(require('../store/flags/state.js'), 'flags/state.js')
  resolveStoreModules(require('../store/homepage/actions.js'), 'homepage/actions.js')
  resolveStoreModules(require('../store/lookbook/actions.js'), 'lookbook/actions.js')
  resolveStoreModules(require('../store/loqate/actions.js'), 'loqate/actions.js')
  resolveStoreModules(require('../store/loqate/mutations.js'), 'loqate/mutations.js')
  resolveStoreModules(require('../store/loqate/state.js'), 'loqate/state.js')
  resolveStoreModules(require('../store/member/actions.js'), 'member/actions.js')
  resolveStoreModules(require('../store/order/actions.js'), 'order/actions.js')
  resolveStoreModules(require('../store/payment/actions.js'), 'payment/actions.js')
  resolveStoreModules(require('../store/payment/getters.js'), 'payment/getters.js')
  resolveStoreModules(require('../store/payment/mutations.js'), 'payment/mutations.js')
  resolveStoreModules(require('../store/payment/state.js'), 'payment/state.js')
  resolveStoreModules(require('../store/paymentContract/actions.js'), 'paymentContract/actions.js')
  resolveStoreModules(require('../store/paymentContract/getters.js'), 'paymentContract/getters.js')
  resolveStoreModules(require('../store/paymentContract/mutations.js'), 'paymentContract/mutations.js')
  resolveStoreModules(require('../store/paymentContract/state.js'), 'paymentContract/state.js')
  resolveStoreModules(require('../store/productGroup/actions.js'), 'productGroup/actions.js')
  resolveStoreModules(require('../store/security/actions.js'), 'security/actions.js')
  resolveStoreModules(require('../store/signup/actions.js'), 'signup/actions.js')
  resolveStoreModules(require('../store/signup/getters.js'), 'signup/getters.js')
  resolveStoreModules(require('../store/signup/mutations.js'), 'signup/mutations.js')
  resolveStoreModules(require('../store/signup/state.js'), 'signup/state.js')
  resolveStoreModules(require('../store/spaaza/actions.js'), 'spaaza/actions.js')
  resolveStoreModules(require('../store/spaaza/mutations.js'), 'spaaza/mutations.js')
  resolveStoreModules(require('../store/spaaza/state.js'), 'spaaza/state.js')
  resolveStoreModules(require('../store/specialDesigns/state.js'), 'specialDesigns/state.js')
  resolveStoreModules(require('../store/user/actions.js'), 'user/actions.js')
  resolveStoreModules(require('../store/webshop/actions.js'), 'webshop/actions.js')
  resolveStoreModules(require('../store/webshop/mutations.js'), 'webshop/mutations.js')
  resolveStoreModules(require('../store/webshop/state.js'), 'webshop/state.js')
  resolveStoreModules(require('../store/womenSignup/mutations.js'), 'womenSignup/mutations.js')
  resolveStoreModules(require('../store/womenSignup/state.js'), 'womenSignup/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
